export default class Required {
  add(element) {
    element.attr('required', true)
  }

  remove(element) {
    element.attr('required', false)
  }
}
